module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-18.cf0f0ca6.png";